import React from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import styled from 'styled-components';
import StatusChips from '../../../../../src/components/library/StatusChips';
import { BrokerJob } from '../../core';
import { JOB_STATUS_META } from '../jobStatusMeta';

const SpinningIcon = styled('span')({
	alignItems: 'center',
	display: 'inline-flex',

	'& svg': {
		animation: 'nx-broker-job-spin 1.4s linear infinite',
	},

	'@keyframes nx-broker-job-spin': {
		to: {
			transform: 'rotate(360deg)',
		},
	},
});

export function StatusCell({ row }: GridRenderCellParams<BrokerJob, string>) {
	const statusMeta = JOB_STATUS_META[row.status];
	const StatusIcon = statusMeta.icon;

	return (
		<StatusChips
			variant="outlined"
			label={statusMeta.label}
			color={statusMeta.color}
			icon={
				statusMeta.spin ? (
					<SpinningIcon>
						<StatusIcon />
					</SpinningIcon>
				) : (
					<StatusIcon />
				)
			}
		/>
	);
}
